module.exports = __webpack_public_path__ + "static/media/supportServices.a07b9cc2.png";